import en from './en.json';
import es from './es.json';

export const skillsTranslations = {
  en: en as Record<string, unknown>,
  es: es as Record<string, unknown>,
};
